import { request } from "../helpers/axios.new";

export const GET_MASTER_BADGE = () => {
  return request({
    url: `/badge/master`,
    method: "GET",
  });
};
